//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DrillSetupSlider from "./DrillSetupSlider";
import { mapState, mapGetters } from "vuex";

export default {
  data: function () {
    return {
      title: "Drill Setup at Control Point",
      chosenDrillVariableValues: null
    };
  },
  computed: {
    ...mapGetters("drilling", ["currentControlPoint"]),
    ...mapState({
      drillSetup: state => state.drilling.drillSetup,
      drillingInProgress: state => state.drilling.drillingInProgress,
    })
  },
  methods: {
    initDrillSetup: function() {
      let temp = {};
      this.drillSetup.forEach(function (item) {
          temp[item.id] = item.values[0];
        });
      this.chosenDrillVariableValues = temp;
      this.$store.commit("drilling/updateChosenDrillSetupValues", temp);
    },
    // sliderChanged() only update one drilling para each, for example AZ2 or IN3
    sliderChanged: function (id, value) {
      if (id != undefined && this.chosenDrillVariableValues[id] != value) {
        this.chosenDrillVariableValues[id] = value;
        this.$store.commit("drilling/updateChosenDrillSetupValues", this.chosenDrillVariableValues);
      }
    },
    confirmDrillSettings: function () {
      this.$emit("drill-settings-confirmed");
    }
  },
  watch: {
    currentControlPoint: function () {
      this.title = "Drill Setup at Control Point" + " [" + this.currentControlPoint + "]";
      this.initDrillSetup();
    }
  },
  components: {
    DrillSetupSlider
  }
};
